// extracted by mini-css-extract-plugin
export default {"noResults":"noResults--lyR4Y"};